/**
 * Calculates the cumulative CSS zoom factor applied to an element by traversing
 * up the DOM tree and multiplying all zoom values.
 *
 * This is useful when dealing with elements inside containers that have CSS `zoom`
 * applied (e.g., PiP mode with `zoom: 0.6`), as it affects coordinate calculations
 * for positioning overlays, handling mouse events, etc.
 *
 * @param element - The element to calculate the zoom factor for
 * @returns The cumulative zoom factor (1 if no zoom is applied)
 */
export function getCssZoomFactor(element: HTMLElement): number {
  let zoom = 1
  let current: HTMLElement | null = element

  while (current) {
    const computedZoom = window.getComputedStyle(current).zoom
    if (computedZoom && computedZoom !== 'normal') {
      const zoomValue = parseFloat(computedZoom)
      if (!isNaN(zoomValue) && zoomValue !== 1) {
        zoom *= zoomValue
      }
    }
    current = current.parentElement
  }

  return zoom
}
